// extracted by css-extract-rspack-plugin
module.exports =  {"root":"FormActions__root___SDe36","box":"FormActions__box___OBPe5"};